import { BaseListComponent } from '../../abstract/base-list.component';
import { Directive } from '@angular/core';


@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class GetWebhookLogsListAction extends BaseListComponent {
  protected _getwebhooktexcel: string;
  protected abstract passwebhookExcelResponse(res);
  protected abstract passwebhookExcelError(err);

  geteventexcel() {
    this.loadFlag = true;
    this.dataManager.getRequestPdf(this._getwebhooktexcel, 0).subscribe(
      (res) => {
        this.loadFlag = false;

        this.passwebhookExcelResponse((new Blob([res], {type: 'application/vnd.ms-excel'})));
      },
      (err) => {
        this.loadFlag = false;
        this.passwebhookExcelError(err);
      },
      // () => this.passstatementPdfComplete()
    );
  }
}
